export const validateEmailAddress = (emailAddress: string) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(emailAddress);
};
